import React from 'react';
import { FiscalYear, VALID_FISCAL_YEARS } from '../../utils/fiscal-year';

export interface FiscalYearPickerProps {
  value: FiscalYear;
  onChange: (fy: FiscalYear) => void;
  disabled?: boolean;
  refreshedAt?: string;
}

/** Formats an ISO timestamp as a short relative age (e.g. "11m ago"). */
export function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) { return 'just now'; }
  if (mins < 60) { return `${mins}m ago`; }
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) { return `${hrs}h ago`; }
  return `${Math.floor(hrs / 24)}d ago`;
}

export function FiscalYearPicker({
  value,
  onChange,
  disabled = false,
  refreshedAt,
}: FiscalYearPickerProps): React.ReactElement {
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 10,
        padding: '0.6rem 1rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <label
        htmlFor="fiscal-year-select"
        style={{
          display: 'block',
          fontSize: '0.7rem',
          color: '#94a3b8',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
        }}
      >
        Period
      </label>
      <select
        id="fiscal-year-select"
        aria-label="Fiscal year period"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as FiscalYear)}
        style={{
          marginTop: '0.25rem',
          width: '100%',
          fontSize: '0.9rem',
          fontWeight: 700,
          color: '#0f172a',
          border: 'none',
          background: 'transparent',
          padding: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
          outline: 'none',
        }}
      >
        {VALID_FISCAL_YEARS.map(fy => (
          <option key={fy} value={fy}>{fy}</option>
        ))}
      </select>
      {refreshedAt && (
        <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: '0.1rem' }}>
          Refreshed {timeAgo(refreshedAt)}
        </div>
      )}
    </div>
  );
}
